import PropTypes from "prop-types";

function P2FolderTabs(props) {
  return (
    <div style={{width: props.tabsContainerWidth}}>
      <div
        className="polymer-folder-tabs-container"
        style={{ ...props.tabsContainerStyle }}
      >
        {props.titles.map((item, _index) => (
          <div
            key={_index}
            className={`polymer-folder-tabs-item ${
              props.selectedTabIndex === _index
                ? "polymer-folder-tabs-item__selected"
                : ""
            }`}
            onClick={() => {
              if (props.onChange) {
                props.onChange(_index);
              }
            }}
            style={{ flexBasis: `${(1 / props.titles.length) * 100}%` }}
          >
            <span className="polymer-folder-tabs-item-content">{item}</span>
          </div>
        ))}
      </div>
      <div
        className="polymer-folder-tabs-content-container"
        style={{ ...props.tabContentContainerStyle }}
      >
        {props.tabContent}
      </div>
    </div>
  );
}

export default P2FolderTabs;

P2FolderTabs.propTypes = {
  tabsContainerWidth: PropTypes.string,
  titles: PropTypes.arrayOf(PropTypes.string),
  selectedTabIndex: PropTypes.number,
  onChange: PropTypes.func,
  tabsContainerStyle: PropTypes.any,
  tabContent: PropTypes.element,
  tabContentContainerStyle: PropTypes.any,
};

P2FolderTabs.defaultProps = {
  titles: [],
  selectedTabIndex: 0,
};
